import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = () => {
	const jsFilterDropDown = $('.js-filter-dropdown');
	const jsCategory = $('.js-category');

	function toggleDropDown(event) {
		event.preventDefault();
		jsFilterDropDown.toggleClass('is-open');
		if (jsFilterDropDown.hasClass('is-open')) {
			jsFilterDropDown.attr('aria-expanded', true);
		} else {
			jsFilterDropDown.attr('aria-expanded', false);
		}
		jsCategory.toggleClass('is-open');
		jsCategory.slideToggle();
	}

	if (MQ('lgUp')) {
		jsFilterDropDown.removeAttr('aria-haspopup');
		jsFilterDropDown.removeAttr('aria-expanded');
	} else if (MQ('mdDown')) {
		jsFilterDropDown.attr('aria-expanded', false);
		jsFilterDropDown.attr('aria-haspopup', true);
	}

	jsFilterDropDown.on('click', toggleDropDown);

	$(window).on('resize', () => {
		if (MQ('mdUp') && jsCategory.attr('style')) {
			jsCategory.removeAttr('style');
		}

		if (MQ('mdUp') && jsCategory.hasClass('is-open')) {
			jsCategory.removeClass('is-open');
			jsFilterDropDown.removeClass('is-open');
			jsFilterDropDown.removeAttr('aria-expanded');
		}
	});
};
